import Axios from "axios";

export default function getSubmitTime(std_id){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getSubmitTime',
            std_id
        }
    });
    return response;
}